import _isEmpty from 'lodash/isEmpty'

export default function (value) {
  if (value && !_isEmpty(value)) {
    return value[0].toUpperCase() + value.slice(1)
  }
  return ''
}
